import React, { useState, useEffect } from 'react';
// @material-ui/core components
import EditIcon from '@material-ui/icons/Edit';
import AddCircle from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import { Link } from 'react-router-dom';
import {
  Table,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter
} from 'reactstrap';
import { makeStyles } from '@material-ui/core/styles';
// core components
import { getAllVendors as getVendorList } from '../../store/actions/admin/Admin';
import { connect } from 'react-redux';
import {
  getAllCategory as getCategoryList,
  getCategoryDetails,
  deleteCategories
} from '../../store/actions/admin/Admin';
import CardHeader from '../../components/Card/CardHeader.js';

const styles = {
  typo: {
    paddingLeft: '25%',
    marginBottom: '40px',
    position: 'relative'
  },
  note: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    bottom: '10px',
    color: '#c0c1c2',
    display: 'block',
    fontWeight: '400',
    fontSize: '13px',
    lineHeight: '13px',
    left: '0',
    marginLeft: '20px',
    position: 'absolute',
    width: '260px'
  },
  cardCategoryWhite: {
    color: 'rgba(255,255,255,.62)',
    margin: '0',
    fontSize: '14px',
    marginTop: '0',
    marginBottom: '0'
  },
  cardTitleWhite: {
    color: '#FFFFFF',
    marginTop: '0px',
    minHeight: 'auto',
    fontWeight: '300',
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: '3px',
    textDecoration: 'none'
  }
};

const useStyles = makeStyles(styles);

const CategoriesTable = (props) => {
  const classes = useStyles();
  const [categorySuper, setCategorySuper] = useState(
    props.match.params.superCategoryId
  );
  const { className } = props;
  const [modal, setModal] = useState(false);
  const [modal2, setModal2] = useState(false);
  const [itemDelete, setItemDelete] = useState(0);

  useEffect(() => {
    props.getCategoryList(props.match.params.superCategoryId);
  }, []);

  const toggle = () => setModal(!modal);
  const toggle2 = () => setModal2(!modal2);

  const fetchDetails = async (categoryId) => {
    props.getCategoryDetails(categoryId);
  };

  const handleDelete = (categoryId) => {
    props.deleteCategories(categoryId).then((data) => {
      if (data) {
        props.getCategoryList(props.match.params.superCategoryId);
        setCategorySuper(props.match.params.superCategoryId);
      }
    });
  };

  return (
    <>
      <CardHeader color="primary">
        <h4 className={classes.cardTitleWhite}>
          All Categories - Add, Update, Delete
        </h4>
        <p className={classes.cardCategoryWhite}>
          PNG Images would be better over JPG or imap
        </p>
      </CardHeader>
      <Table hover>
        <thead>
          <tr>
            <th>#</th>
            <th>Added By</th>
            <th>Name</th>
            <th>Icon</th>
            <th>Sub-Category</th>
            <th>Add</th>
            <th>Update</th>
            <th>Delete</th>
          </tr>
        </thead>
        <tbody>
          {props.categories.length !== 0 ? (
            props.categories.map((item, i) => (
              <tr key={item.id}>
                <th scope="row">{i + 1}</th>
                {props.allVendors.filter(
                  (categorieFilter) => categorieFilter.id === item.addedBy
                ).length > 0 ? (
                  props.allVendors
                    .filter(
                      (categorieFilter) => categorieFilter.id === item.addedBy
                    )
                    .map((type) => <td key={type.id}>{type.name}</td>)
                ) : (
                  <td> A {item.userRoleOfAddedBy} </td>
                )}
                <td>{item.name}</td>
                <td>
                  <img
                    className="img-fluid"
                    src={item.icon}
                    alt={item.name}
                    style={{ height: '80px' }}
                  />
                </td>
                <td>
                  <Link
                    style={{ color: '#932BAD', textDecoration: 'none' }}
                    to={
                      '/admin/sub-category/' +
                      item.superCategoryId +
                      '/' +
                      item.id
                    }
                  >
                    View All
                  </Link>
                </td>
                <td>
                  <Link
                    style={{ color: '#932BAD', textDecoration: 'none' }}
                    to={
                      '/admin/add-sub-category/' + categorySuper + '/' + item.id
                    }
                  >
                    <AddCircle
                      onClick={function (event) {
                        toggle();
                        fetchDetails(item.id);
                      }}
                    />{' '}
                    Add subCategory
                  </Link>
                </td>
                <td>
                  <Link
                    style={{ color: '#000' }}
                    to={
                      '/admin/category-edit/' +
                      item.superCategoryId +
                      '/' +
                      item.id
                    }
                  >
                    <EditIcon
                      onClick={function (event) {
                        toggle();
                        fetchDetails(item.id);
                      }}
                    />{' '}
                  </Link>
                </td>
                <td>
                  <DeleteIcon
                    onClick={function (event) {
                      toggle();
                      setItemDelete(item.id);
                    }}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td></td>
              <td>No data yet</td>
              <td></td>
              <td>No data yet</td>
              <td></td>
              <td>No data yet</td>
            </tr>
          )}
        </tbody>
      </Table>

      <Modal isOpen={modal} toggle={toggle} className={className}>
        <ModalHeader toggle={toggle}>Delete</ModalHeader>
        <ModalBody>Do you really want to delete this Category??</ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal isOpen={modal2} toggle={toggle2} className={className}>
        <ModalHeader toggle={toggle2}>Modify a category</ModalHeader>
        <ModalBody></ModalBody>
        <ModalFooter>
          <Button
            color="primary"
            onClick={function (event) {
              handleDelete(itemDelete);
              toggle();
            }}
          >
            Delete
          </Button>{' '}
          <Button color="secondary" onClick={toggle2}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Link to={'/admin/add-category/' + categorySuper}>
        <a
          classsName="float-button"
          style={{
            position: 'fixed',
            width: '60px',
            height: '60px',
            bottom: '80px',
            right: '20px',
            backgroundColor: '#A742B9',
            color: '#FFF',
            borderRadius: '50px',
            textAlign: 'center',
            boxShadow: '2px 2px 3px #A742B9'
          }}
          href="//#endregion"
        >
          <i
            className="fa fa-plus my-float-button"
            style={{ marginTop: '22px', fontWeight: 600 }}
          >
            {' '}
            Add
          </i>
        </a>{' '}
      </Link>
    </>
  );
};

const mapStateWithProps = (state) => ({
  allVendors: state.admin.allVendors,
  categories: state.admin.categories,
  categoryDetails: state.admin.categoryDetails
});
const mapDispatchWithProps = (dispatch) => {
  return {
    getVendorList: () => dispatch(getVendorList()),
    getCategoryList: (superCategoryId) =>
      dispatch(getCategoryList(superCategoryId, 10000)),
    getCategoryDetails: (categoryId) =>
      dispatch(getCategoryDetails(categoryId)),
    deleteCategories: (categoryId) => dispatch(deleteCategories(categoryId))
  };
};

export default connect(
  mapStateWithProps,
  mapDispatchWithProps
)(CategoriesTable);
